import { FC } from "react";
import { Button, HStack, Text, useToast } from "@chakra-ui/react";

import { CopyIcon } from "../../../../icons";

export const DEFAULT_PROFILE_TEXT = "-";

interface Props {
  title: string;
  text: string | undefined;
  isCopyEnabled?: boolean;
}

export const ProfileText: FC<Props> = ({ title, text, isCopyEnabled = false }) => {
  const toast = useToast();

  const onCopy = async () => {
    await navigator.clipboard.writeText(text!);

    toast({
      id: "text-copied",
      description: "Скопировано",
    });
  };

  if (!text) {
    return null;
  }

  return (
    <>
      <Text mb="5px" fontSize="14px" letterSpacing="3%">
        {title}
      </Text>

      <HStack mb="18px" spacing="12px" alignItems="flex-start">
        <Text variant="brand" letterSpacing="2%">{text}</Text>

        {isCopyEnabled && text !== DEFAULT_PROFILE_TEXT && (
          <Button minW="20px" h="20px" p="0" colorScheme="transparent" onClick={onCopy}>
            <CopyIcon />
          </Button>
        )}
      </HStack>
    </>
  );
};
